import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedResult } from '../models/paged-result';
import { ServiceCode, ServiceCodeLookup } from '../models/service-code';

@Injectable({ providedIn: 'root' })
export class CodigosServicoService {
  private readonly baseUrl = `${environment.apis.unified.baseUrl}/service-code`;

  constructor(private http: HttpClient) { }

  getAll(params: any, skipGlobalErrors = true): Observable<PagedResult<ServiceCode>> {
    return this.http.get<PagedResult<ServiceCode>>(this.baseUrl, { params, headers: this.headers(skipGlobalErrors) });
  }

  getActive(skipGlobalErrors = true): Observable<ServiceCodeLookup[]> {
    return this.http.get<ServiceCodeLookup[]>(`${this.baseUrl}/active`, { headers: this.headers(skipGlobalErrors) });
  }

  create(data: any, skipGlobalErrors = true) {
    return this.http.post(this.baseUrl, data, { headers: this.headers(skipGlobalErrors) });
  }

  update(id: string, data: any, skipGlobalErrors = true) {
    return this.http.put(`${this.baseUrl}/${id}`, data, { headers: this.headers(skipGlobalErrors) });
  }

  delete(id: string, skipGlobalErrors = true) {
    return this.http.delete(`${this.baseUrl}/${id}`, { headers: this.headers(skipGlobalErrors) });
  }

  private headers(skipGlobalErrors: boolean): HttpHeaders | undefined {
    return skipGlobalErrors ? new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) : undefined;
  }
}
